/**
 * The way back from a company to the list it was opened from, filters and all.
 *
 * The list keeps its filters in the URL, so the browser's Back already gets
 * there -- but only straight back. Open a company, then a contact, then the
 * company again, and Back is three presses; arrive from a link in a ticket and
 * it is somewhere else entirely; and an installed app on a phone has no Back
 * button at all. So the list writes down where it was, for this tab, and the
 * company page's "‹ Companies" goes there.
 *
 * Per tab (sessionStorage), not per person: two tabs filtered two ways should
 * each go back to their own list.
 */

const KEY = "pulse.crm.companies.search";

export function rememberCompaniesSearch(search: string): void {
  try {
    window.sessionStorage.setItem(KEY, search);
  } catch {
    /* Blocked storage: the link falls back to the bare list. */
  }
}

/** The list as it was last seen in this tab, or the bare list. */
export function companiesListHref(): string {
  try {
    const search = window.sessionStorage.getItem(KEY);
    return search ? `/crm/companies?${search}` : "/crm/companies";
  } catch {
    return "/crm/companies";
  }
}
